import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Flex } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { StringContextType } from "@faire/web-api--source/faire/translator/StringContextType";
import React from "react";
import styled from "styled-components";
export var SkipButtonConditionally = function SkipButtonConditionally(_ref) {
  var onClick = _ref.onClick;
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  return /*#__PURE__*/React.createElement(SkipButtonWrapper, null, /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }), /*#__PURE__*/React.createElement(SkipButton, {
    onClick: onClick
  }), isMobile ? null : /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }));
};
var SkipButton = function SkipButton(props) {
  return /*#__PURE__*/React.createElement(StyledButton, _objectSpread({
    small: true,
    variant: "secondary",
    "data-test-id": "skip-order-page-btn"
  }, props), /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ZMAVal",
    defaultMessage: "No, skip this step"
  }));
};
var StyledButton = styled(Button).withConfig({
  displayName: "SkipButton__StyledButton"
})(["&:hover{color:", ";background-color:", ";}padding:", "};", "{width:100%;}"], Core.text.hover, Core.text.inverse, getSpacing("3x"), responsiveMediaQueries.mobile);
var SkipButtonWrapper = styled(Flex).attrs({
  direction: {
    tabletAndAbove: "row",
    mobileAndAbove: "column"
  }
}).withConfig({
  displayName: "SkipButton__SkipButtonWrapper"
})(["", "{width:100%;}"], responsiveMediaQueries.mobile);